import Typography from '../../core/Typography';
import { SingleToolAppIcon } from '../SingleToolAppIcon';

import { ISameCategoryCardProps } from './types';
import useStyles from './SameCategoryCardStyles';

export default function SameCategoryCard({
  text,
  href,
  iconProps,
  element = 'li',
  onClick,
}: ISameCategoryCardProps) {
  const classes = useStyles();

  return (
    <Typography className={classes.root} element={element}>
      <a onClick={onClick} href={href} className={classes.link}>
        <div className={classes.textContainer}>
          <SingleToolAppIcon {...iconProps} />
          <span className={classes.text}>{text}</span>
        </div>
      </a>
    </Typography>
  );
}
